module.exports = __webpack_public_path__ + "img/6763bb4.jpg";